import He from "react";
var X = { exports: {} }, M = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function bt() {
  if (Fe)
    return M;
  Fe = 1;
  var i = He, a = Symbol.for("react.element"), e = Symbol.for("react.fragment"), t = Object.prototype.hasOwnProperty, n = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, f, d) {
    var g, h = {}, b = null, v = null;
    d !== void 0 && (b = "" + d), f.key !== void 0 && (b = "" + f.key), f.ref !== void 0 && (v = f.ref);
    for (g in f)
      t.call(f, g) && !o.hasOwnProperty(g) && (h[g] = f[g]);
    if (u && u.defaultProps)
      for (g in f = u.defaultProps, f)
        h[g] === void 0 && (h[g] = f[g]);
    return { $$typeof: a, type: u, key: b, ref: v, props: h, _owner: n.current };
  }
  return M.Fragment = e, M.jsx = l, M.jsxs = l, M;
}
var U = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ae;
function Et() {
  return Ae || (Ae = 1, process.env.NODE_ENV !== "production" && function() {
    var i = He, a = Symbol.for("react.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), T = Symbol.iterator, P = "@@iterator";
    function k(r) {
      if (r === null || typeof r != "object")
        return null;
      var s = T && r[T] || r[P];
      return typeof s == "function" ? s : null;
    }
    var w = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), p = 1; p < s; p++)
          c[p - 1] = arguments[p];
        H("error", r, c);
      }
    }
    function H(r, s, c) {
      {
        var p = w.ReactDebugCurrentFrame, x = p.getStackAddendum();
        x !== "" && (s += "%s", c = c.concat([x]));
        var C = c.map(function(E) {
          return String(E);
        });
        C.unshift("Warning: " + s), Function.prototype.apply.call(console[r], console, C);
      }
    }
    var Ue = !1, Ve = !1, Ye = !1, Be = !1, $e = !1, ue;
    ue = Symbol.for("react.module.reference");
    function qe(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === t || r === o || $e || r === n || r === d || r === g || Be || r === v || Ue || Ve || Ye || typeof r == "object" && r !== null && (r.$$typeof === b || r.$$typeof === h || r.$$typeof === l || r.$$typeof === u || r.$$typeof === f || r.$$typeof === ue || r.getModuleId !== void 0));
    }
    function Xe(r, s, c) {
      var p = r.displayName;
      if (p)
        return p;
      var x = s.displayName || s.name || "";
      return x !== "" ? c + "(" + x + ")" : c;
    }
    function le(r) {
      return r.displayName || "Context";
    }
    function A(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case t:
          return "Fragment";
        case e:
          return "Portal";
        case o:
          return "Profiler";
        case n:
          return "StrictMode";
        case d:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            var s = r;
            return le(s) + ".Consumer";
          case l:
            var c = r;
            return le(c._context) + ".Provider";
          case f:
            return Xe(r, r.render, "ForwardRef");
          case h:
            var p = r.displayName || null;
            return p !== null ? p : A(r.type) || "Memo";
          case b: {
            var x = r, C = x._payload, E = x._init;
            try {
              return A(E(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, D = 0, se, fe, ce, de, ve, ge, pe;
    function ye() {
    }
    ye.__reactDisabledLog = !0;
    function Ze() {
      {
        if (D === 0) {
          se = console.log, fe = console.info, ce = console.warn, de = console.error, ve = console.group, ge = console.groupCollapsed, pe = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        D++;
      }
    }
    function Je() {
      {
        if (D--, D === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, r, {
              value: se
            }),
            info: W({}, r, {
              value: fe
            }),
            warn: W({}, r, {
              value: ce
            }),
            error: W({}, r, {
              value: de
            }),
            group: W({}, r, {
              value: ve
            }),
            groupCollapsed: W({}, r, {
              value: ge
            }),
            groupEnd: W({}, r, {
              value: pe
            })
          });
        }
        D < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = w.ReactCurrentDispatcher, J;
    function V(r, s, c) {
      {
        if (J === void 0)
          try {
            throw Error();
          } catch (x) {
            var p = x.stack.trim().match(/\n( *(at )?)/);
            J = p && p[1] || "";
          }
        return `
` + J + r;
      }
    }
    var z = !1, Y;
    {
      var ze = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new ze();
    }
    function he(r, s) {
      if (!r || z)
        return "";
      {
        var c = Y.get(r);
        if (c !== void 0)
          return c;
      }
      var p;
      z = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = Z.current, Z.current = null, Ze();
      try {
        if (s) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (I) {
              p = I;
            }
            Reflect.construct(r, [], E);
          } else {
            try {
              E.call();
            } catch (I) {
              p = I;
            }
            r.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (I) {
            p = I;
          }
          r();
        }
      } catch (I) {
        if (I && p && typeof I.stack == "string") {
          for (var m = I.stack.split(`
`), R = p.stack.split(`
`), S = m.length - 1, O = R.length - 1; S >= 1 && O >= 0 && m[S] !== R[O]; )
            O--;
          for (; S >= 1 && O >= 0; S--, O--)
            if (m[S] !== R[O]) {
              if (S !== 1 || O !== 1)
                do
                  if (S--, O--, O < 0 || m[S] !== R[O]) {
                    var F = `
` + m[S].replace(" at new ", " at ");
                    return r.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", r.displayName)), typeof r == "function" && Y.set(r, F), F;
                  }
                while (S >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        z = !1, Z.current = C, Je(), Error.prepareStackTrace = x;
      }
      var j = r ? r.displayName || r.name : "", Pe = j ? V(j) : "";
      return typeof r == "function" && Y.set(r, Pe), Pe;
    }
    function Ke(r, s, c) {
      return he(r, !1);
    }
    function Ge(r) {
      var s = r.prototype;
      return !!(s && s.isReactComponent);
    }
    function B(r, s, c) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return he(r, Ge(r));
      if (typeof r == "string")
        return V(r);
      switch (r) {
        case d:
          return V("Suspense");
        case g:
          return V("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case f:
            return Ke(r.render);
          case h:
            return B(r.type, s, c);
          case b: {
            var p = r, x = p._payload, C = p._init;
            try {
              return B(C(x), s, c);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, me = {}, be = w.ReactDebugCurrentFrame;
    function q(r) {
      if (r) {
        var s = r._owner, c = B(r.type, r._source, s ? s.type : null);
        be.setExtraStackFrame(c);
      } else
        be.setExtraStackFrame(null);
    }
    function Qe(r, s, c, p, x) {
      {
        var C = Function.call.bind($);
        for (var E in r)
          if (C(r, E)) {
            var m = void 0;
            try {
              if (typeof r[E] != "function") {
                var R = Error((p || "React class") + ": " + c + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              m = r[E](s, E, p, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (S) {
              m = S;
            }
            m && !(m instanceof Error) && (q(x), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", c, E, typeof m), q(null)), m instanceof Error && !(m.message in me) && (me[m.message] = !0, q(x), y("Failed %s type: %s", c, m.message), q(null));
          }
      }
    }
    var et = Array.isArray;
    function K(r) {
      return et(r);
    }
    function tt(r) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, c = s && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return c;
      }
    }
    function rt(r) {
      try {
        return Ee(r), !1;
      } catch {
        return !0;
      }
    }
    function Ee(r) {
      return "" + r;
    }
    function we(r) {
      if (rt(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tt(r)), Ee(r);
    }
    var N = w.ReactCurrentOwner, nt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, Ce, G;
    G = {};
    function at(r) {
      if ($.call(r, "ref")) {
        var s = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function it(r) {
      if ($.call(r, "key")) {
        var s = Object.getOwnPropertyDescriptor(r, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function ot(r, s) {
      if (typeof r.ref == "string" && N.current && s && N.current.stateNode !== s) {
        var c = A(N.current.type);
        G[c] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(N.current.type), r.ref), G[c] = !0);
      }
    }
    function ut(r, s) {
      {
        var c = function() {
          xe || (xe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        c.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: c,
          configurable: !0
        });
      }
    }
    function lt(r, s) {
      {
        var c = function() {
          Ce || (Ce = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        c.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: c,
          configurable: !0
        });
      }
    }
    var st = function(r, s, c, p, x, C, E) {
      var m = {
        $$typeof: a,
        type: r,
        key: s,
        ref: c,
        props: E,
        _owner: C
      };
      return m._store = {}, Object.defineProperty(m._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(m, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.defineProperty(m, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(m.props), Object.freeze(m)), m;
    };
    function ft(r, s, c, p, x) {
      {
        var C, E = {}, m = null, R = null;
        c !== void 0 && (we(c), m = "" + c), it(s) && (we(s.key), m = "" + s.key), at(s) && (R = s.ref, ot(s, x));
        for (C in s)
          $.call(s, C) && !nt.hasOwnProperty(C) && (E[C] = s[C]);
        if (r && r.defaultProps) {
          var S = r.defaultProps;
          for (C in S)
            E[C] === void 0 && (E[C] = S[C]);
        }
        if (m || R) {
          var O = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          m && ut(E, O), R && lt(E, O);
        }
        return st(r, m, R, x, p, N.current, E);
      }
    }
    var Q = w.ReactCurrentOwner, Se = w.ReactDebugCurrentFrame;
    function L(r) {
      if (r) {
        var s = r._owner, c = B(r.type, r._source, s ? s.type : null);
        Se.setExtraStackFrame(c);
      } else
        Se.setExtraStackFrame(null);
    }
    var ee;
    ee = !1;
    function te(r) {
      return typeof r == "object" && r !== null && r.$$typeof === a;
    }
    function Oe() {
      {
        if (Q.current) {
          var r = A(Q.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function ct(r) {
      {
        if (r !== void 0) {
          var s = r.fileName.replace(/^.*[\\\/]/, ""), c = r.lineNumber;
          return `

Check your code at ` + s + ":" + c + ".";
        }
        return "";
      }
    }
    var Te = {};
    function dt(r) {
      {
        var s = Oe();
        if (!s) {
          var c = typeof r == "string" ? r : r.displayName || r.name;
          c && (s = `

Check the top-level render call using <` + c + ">.");
        }
        return s;
      }
    }
    function Re(r, s) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var c = dt(s);
        if (Te[c])
          return;
        Te[c] = !0;
        var p = "";
        r && r._owner && r._owner !== Q.current && (p = " It was passed a child from " + A(r._owner.type) + "."), L(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, p), L(null);
      }
    }
    function ke(r, s) {
      {
        if (typeof r != "object")
          return;
        if (K(r))
          for (var c = 0; c < r.length; c++) {
            var p = r[c];
            te(p) && Re(p, s);
          }
        else if (te(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var x = k(r);
          if (typeof x == "function" && x !== r.entries)
            for (var C = x.call(r), E; !(E = C.next()).done; )
              te(E.value) && Re(E.value, s);
        }
      }
    }
    function vt(r) {
      {
        var s = r.type;
        if (s == null || typeof s == "string")
          return;
        var c;
        if (typeof s == "function")
          c = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === f || s.$$typeof === h))
          c = s.propTypes;
        else
          return;
        if (c) {
          var p = A(s);
          Qe(c, r.props, "prop", p, r);
        } else if (s.PropTypes !== void 0 && !ee) {
          ee = !0;
          var x = A(s);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gt(r) {
      {
        for (var s = Object.keys(r.props), c = 0; c < s.length; c++) {
          var p = s[c];
          if (p !== "children" && p !== "key") {
            L(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", p), L(null);
            break;
          }
        }
        r.ref !== null && (L(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), L(null));
      }
    }
    function _e(r, s, c, p, x, C) {
      {
        var E = qe(r);
        if (!E) {
          var m = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (m += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = ct(x);
          R ? m += R : m += Oe();
          var S;
          r === null ? S = "null" : K(r) ? S = "array" : r !== void 0 && r.$$typeof === a ? (S = "<" + (A(r.type) || "Unknown") + " />", m = " Did you accidentally export a JSX literal instead of a component?") : S = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", S, m);
        }
        var O = ft(r, s, c, x, C);
        if (O == null)
          return O;
        if (E) {
          var F = s.children;
          if (F !== void 0)
            if (p)
              if (K(F)) {
                for (var j = 0; j < F.length; j++)
                  ke(F[j], r);
                Object.freeze && Object.freeze(F);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ke(F, r);
        }
        return r === t ? gt(O) : vt(O), O;
      }
    }
    function pt(r, s, c) {
      return _e(r, s, c, !0);
    }
    function yt(r, s, c) {
      return _e(r, s, c, !1);
    }
    var ht = yt, mt = pt;
    U.Fragment = t, U.jsx = ht, U.jsxs = mt;
  }()), U;
}
(function(i) {
  process.env.NODE_ENV === "production" ? i.exports = bt() : i.exports = Et();
})(X);
const jt = X.exports.Fragment, wt = X.exports.jsx, Ht = X.exports.jsxs;
function xt(i) {
  if (Array.isArray(i))
    return i;
}
function Ct(i, a) {
  var e = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (e != null) {
    var t = [], n = !0, o = !1, l, u;
    try {
      for (e = e.call(i); !(n = (l = e.next()).done) && (t.push(l.value), !(a && t.length === a)); n = !0)
        ;
    } catch (f) {
      o = !0, u = f;
    } finally {
      try {
        !n && e.return != null && e.return();
      } finally {
        if (o)
          throw u;
      }
    }
    return t;
  }
}
function ne(i, a) {
  (a == null || a > i.length) && (a = i.length);
  for (var e = 0, t = new Array(a); e < a; e++)
    t[e] = i[e];
  return t;
}
function De(i, a) {
  if (!!i) {
    if (typeof i == "string")
      return ne(i, a);
    var e = Object.prototype.toString.call(i).slice(8, -1);
    if (e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set")
      return Array.from(i);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return ne(i, a);
  }
}
function St() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ot(i, a) {
  return xt(i) || Ct(i, a) || De(i, a) || St();
}
function _(i) {
  return _ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _(i);
}
function Tt() {
  for (var i = arguments.length, a = new Array(i), e = 0; e < i; e++)
    a[e] = arguments[e];
  if (a) {
    for (var t = [], n = 0; n < a.length; n++) {
      var o = a[n];
      if (!!o) {
        var l = _(o);
        if (l === "string" || l === "number")
          t.push(o);
        else if (l === "object") {
          var u = Array.isArray(o) ? o : Object.entries(o).map(function(f) {
            var d = Ot(f, 2), g = d[0], h = d[1];
            return h ? g : null;
          });
          t = u.length ? t.concat(u.filter(function(f) {
            return !!f;
          })) : t;
        }
      }
    }
    return t.join(" ");
  }
}
function ae(i, a) {
  if (!(i instanceof a))
    throw new TypeError("Cannot call a class as a function");
}
function Ie(i, a) {
  for (var e = 0; e < a.length; e++) {
    var t = a[e];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(i, t.key, t);
  }
}
function ie(i, a, e) {
  return a && Ie(i.prototype, a), e && Ie(i, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function oe(i, a, e) {
  return a in i ? Object.defineProperty(i, a, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[a] = e, i;
}
function re(i, a) {
  var e = typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (!e) {
    if (Array.isArray(i) || (e = Rt(i)) || a && i && typeof i.length == "number") {
      e && (i = e);
      var t = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return t >= i.length ? {
            done: !0
          } : {
            done: !1,
            value: i[t++]
          };
        },
        e: function(d) {
          throw d;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = !0, l = !1, u;
  return {
    s: function() {
      e = e.call(i);
    },
    n: function() {
      var d = e.next();
      return o = d.done, d;
    },
    e: function(d) {
      l = !0, u = d;
    },
    f: function() {
      try {
        !o && e.return != null && e.return();
      } finally {
        if (l)
          throw u;
      }
    }
  };
}
function Rt(i, a) {
  if (!!i) {
    if (typeof i == "string")
      return We(i, a);
    var e = Object.prototype.toString.call(i).slice(8, -1);
    if (e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set")
      return Array.from(i);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return We(i, a);
  }
}
function We(i, a) {
  (a == null || a > i.length) && (a = i.length);
  for (var e = 0, t = new Array(a); e < a; e++)
    t[e] = i[e];
  return t;
}
var Ne = /* @__PURE__ */ function() {
  function i() {
    ae(this, i);
  }
  return ie(i, null, [{
    key: "innerWidth",
    value: function(e) {
      if (e) {
        var t = e.offsetWidth, n = getComputedStyle(e);
        return t += parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), t;
      }
      return 0;
    }
  }, {
    key: "width",
    value: function(e) {
      if (e) {
        var t = e.offsetWidth, n = getComputedStyle(e);
        return t -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), t;
      }
      return 0;
    }
  }, {
    key: "getBrowserLanguage",
    value: function() {
      return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || "en";
    }
  }, {
    key: "getWindowScrollTop",
    value: function() {
      var e = document.documentElement;
      return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
    }
  }, {
    key: "getWindowScrollLeft",
    value: function() {
      var e = document.documentElement;
      return (window.pageXOffset || e.scrollLeft) - (e.clientLeft || 0);
    }
  }, {
    key: "getOuterWidth",
    value: function(e, t) {
      if (e) {
        var n = e.offsetWidth || e.getBoundingClientRect().width;
        if (t) {
          var o = getComputedStyle(e);
          n += parseFloat(o.marginLeft) + parseFloat(o.marginRight);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getOuterHeight",
    value: function(e, t) {
      if (e) {
        var n = e.offsetHeight || e.getBoundingClientRect().height;
        if (t) {
          var o = getComputedStyle(e);
          n += parseFloat(o.marginTop) + parseFloat(o.marginBottom);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getClientHeight",
    value: function(e, t) {
      if (e) {
        var n = e.clientHeight;
        if (t) {
          var o = getComputedStyle(e);
          n += parseFloat(o.marginTop) + parseFloat(o.marginBottom);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getClientWidth",
    value: function(e, t) {
      if (e) {
        var n = e.clientWidth;
        if (t) {
          var o = getComputedStyle(e);
          n += parseFloat(o.marginLeft) + parseFloat(o.marginRight);
        }
        return n;
      }
      return 0;
    }
  }, {
    key: "getViewport",
    value: function() {
      var e = window, t = document, n = t.documentElement, o = t.getElementsByTagName("body")[0], l = e.innerWidth || n.clientWidth || o.clientWidth, u = e.innerHeight || n.clientHeight || o.clientHeight;
      return {
        width: l,
        height: u
      };
    }
  }, {
    key: "getOffset",
    value: function(e) {
      if (e) {
        var t = e.getBoundingClientRect();
        return {
          top: t.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
          left: t.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
        };
      }
      return {
        top: "auto",
        left: "auto"
      };
    }
  }, {
    key: "index",
    value: function(e) {
      if (e)
        for (var t = e.parentNode.childNodes, n = 0, o = 0; o < t.length; o++) {
          if (t[o] === e)
            return n;
          t[o].nodeType === 1 && n++;
        }
      return -1;
    }
  }, {
    key: "addMultipleClasses",
    value: function(e, t) {
      if (e && t)
        if (e.classList)
          for (var n = t.split(" "), o = 0; o < n.length; o++)
            e.classList.add(n[o]);
        else
          for (var l = t.split(" "), u = 0; u < l.length; u++)
            e.className += " " + l[u];
    }
  }, {
    key: "removeMultipleClasses",
    value: function(e, t) {
      if (e && t)
        if (e.classList)
          for (var n = t.split(" "), o = 0; o < n.length; o++)
            e.classList.remove(n[o]);
        else
          for (var l = t.split(" "), u = 0; u < l.length; u++)
            e.className = e.className.replace(new RegExp("(^|\\b)" + l[u].split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
  }, {
    key: "addClass",
    value: function(e, t) {
      e && t && (e.classList ? e.classList.add(t) : e.className += " " + t);
    }
  }, {
    key: "removeClass",
    value: function(e, t) {
      e && t && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " "));
    }
  }, {
    key: "hasClass",
    value: function(e, t) {
      return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
    }
  }, {
    key: "find",
    value: function(e, t) {
      return e ? Array.from(e.querySelectorAll(t)) : [];
    }
  }, {
    key: "findSingle",
    value: function(e, t) {
      return e ? e.querySelector(t) : null;
    }
  }, {
    key: "getHeight",
    value: function(e) {
      if (e) {
        var t = e.offsetHeight, n = getComputedStyle(e);
        return t -= parseFloat(n.paddingTop) + parseFloat(n.paddingBottom) + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), t;
      }
      return 0;
    }
  }, {
    key: "getWidth",
    value: function(e) {
      if (e) {
        var t = e.offsetWidth, n = getComputedStyle(e);
        return t -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderLeftWidth) + parseFloat(n.borderRightWidth), t;
      }
      return 0;
    }
  }, {
    key: "alignOverlay",
    value: function(e, t, n) {
      var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
      e && t && (n === "self" ? this.relativePosition(e, t) : (o && (e.style.minWidth = i.getOuterWidth(t) + "px"), this.absolutePosition(e, t)));
    }
  }, {
    key: "absolutePosition",
    value: function(e, t) {
      if (e) {
        var n = e.offsetParent ? {
          width: e.offsetWidth,
          height: e.offsetHeight
        } : this.getHiddenElementDimensions(e), o = n.height, l = n.width, u = t.offsetHeight, f = t.offsetWidth, d = t.getBoundingClientRect(), g = this.getWindowScrollTop(), h = this.getWindowScrollLeft(), b = this.getViewport(), v, T;
        d.top + u + o > b.height ? (v = d.top + g - o, v < 0 && (v = g), e.style.transformOrigin = "bottom") : (v = u + d.top + g, e.style.transformOrigin = "top"), d.left + f + l > b.width ? T = Math.max(0, d.left + h + f - l) : T = d.left + h, e.style.top = v + "px", e.style.left = T + "px";
      }
    }
  }, {
    key: "relativePosition",
    value: function(e, t) {
      if (e) {
        var n = e.offsetParent ? {
          width: e.offsetWidth,
          height: e.offsetHeight
        } : this.getHiddenElementDimensions(e), o = t.offsetHeight, l = t.getBoundingClientRect(), u = this.getViewport(), f, d;
        l.top + o + n.height > u.height ? (f = -1 * n.height, l.top + f < 0 && (f = -1 * l.top), e.style.transformOrigin = "bottom") : (f = o, e.style.transformOrigin = "top"), n.width > u.width ? d = l.left * -1 : l.left + n.width > u.width ? d = (l.left + n.width - u.width) * -1 : d = 0, e.style.top = f + "px", e.style.left = d + "px";
      }
    }
  }, {
    key: "flipfitCollision",
    value: function(e, t) {
      var n = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "left top", l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "left bottom", u = arguments.length > 4 ? arguments[4] : void 0;
      if (e && t) {
        var f = t.getBoundingClientRect(), d = this.getViewport(), g = o.split(" "), h = l.split(" "), b = function(w, y) {
          return y ? +w.substring(w.search(/(\+|-)/g)) || 0 : w.substring(0, w.search(/(\+|-)/g)) || w;
        }, v = {
          my: {
            x: b(g[0]),
            y: b(g[1] || g[0]),
            offsetX: b(g[0], !0),
            offsetY: b(g[1] || g[0], !0)
          },
          at: {
            x: b(h[0]),
            y: b(h[1] || h[0]),
            offsetX: b(h[0], !0),
            offsetY: b(h[1] || h[0], !0)
          }
        }, T = {
          left: function() {
            var w = v.my.offsetX + v.at.offsetX;
            return w + f.left + (v.my.x === "left" ? 0 : -1 * (v.my.x === "center" ? n.getOuterWidth(e) / 2 : n.getOuterWidth(e)));
          },
          top: function() {
            var w = v.my.offsetY + v.at.offsetY;
            return w + f.top + (v.my.y === "top" ? 0 : -1 * (v.my.y === "center" ? n.getOuterHeight(e) / 2 : n.getOuterHeight(e)));
          }
        }, P = {
          count: {
            x: 0,
            y: 0
          },
          left: function() {
            var w = T.left(), y = i.getWindowScrollLeft();
            e.style.left = w + y + "px", this.count.x === 2 ? (e.style.left = y + "px", this.count.x = 0) : w < 0 && (this.count.x++, v.my.x = "left", v.at.x = "right", v.my.offsetX *= -1, v.at.offsetX *= -1, this.right());
          },
          right: function() {
            var w = T.left() + i.getOuterWidth(t), y = i.getWindowScrollLeft();
            e.style.left = w + y + "px", this.count.x === 2 ? (e.style.left = d.width - i.getOuterWidth(e) + y + "px", this.count.x = 0) : w + i.getOuterWidth(e) > d.width && (this.count.x++, v.my.x = "right", v.at.x = "left", v.my.offsetX *= -1, v.at.offsetX *= -1, this.left());
          },
          top: function() {
            var w = T.top(), y = i.getWindowScrollTop();
            e.style.top = w + y + "px", this.count.y === 2 ? (e.style.left = y + "px", this.count.y = 0) : w < 0 && (this.count.y++, v.my.y = "top", v.at.y = "bottom", v.my.offsetY *= -1, v.at.offsetY *= -1, this.bottom());
          },
          bottom: function() {
            var w = T.top() + i.getOuterHeight(t), y = i.getWindowScrollTop();
            e.style.top = w + y + "px", this.count.y === 2 ? (e.style.left = d.height - i.getOuterHeight(e) + y + "px", this.count.y = 0) : w + i.getOuterHeight(t) > d.height && (this.count.y++, v.my.y = "bottom", v.at.y = "top", v.my.offsetY *= -1, v.at.offsetY *= -1, this.top());
          },
          center: function(w) {
            if (w === "y") {
              var y = T.top() + i.getOuterHeight(t) / 2;
              e.style.top = y + i.getWindowScrollTop() + "px", y < 0 ? this.bottom() : y + i.getOuterHeight(t) > d.height && this.top();
            } else {
              var H = T.left() + i.getOuterWidth(t) / 2;
              e.style.left = H + i.getWindowScrollLeft() + "px", H < 0 ? this.left() : H + i.getOuterWidth(e) > d.width && this.right();
            }
          }
        };
        P[v.at.x]("x"), P[v.at.y]("y"), this.isFunction(u) && u(v);
      }
    }
  }, {
    key: "findCollisionPosition",
    value: function(e) {
      if (e) {
        var t = e === "top" || e === "bottom", n = e === "left" ? "right" : "left", o = e === "top" ? "bottom" : "top";
        return t ? {
          axis: "y",
          my: "center ".concat(o),
          at: "center ".concat(e)
        } : {
          axis: "x",
          my: "".concat(n, " center"),
          at: "".concat(e, " center")
        };
      }
    }
  }, {
    key: "getParents",
    value: function(e) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      return e.parentNode === null ? t : this.getParents(e.parentNode, t.concat([e.parentNode]));
    }
  }, {
    key: "getScrollableParents",
    value: function(e) {
      var t = [];
      if (e) {
        var n = this.getParents(e), o = /(auto|scroll)/, l = function(w) {
          var y = w ? getComputedStyle(w) : null;
          return y && (o.test(y.getPropertyValue("overflow")) || o.test(y.getPropertyValue("overflowX")) || o.test(y.getPropertyValue("overflowY")));
        }, u = re(n), f;
        try {
          for (u.s(); !(f = u.n()).done; ) {
            var d = f.value, g = d.nodeType === 1 && d.dataset.scrollselectors;
            if (g) {
              var h = g.split(","), b = re(h), v;
              try {
                for (b.s(); !(v = b.n()).done; ) {
                  var T = v.value, P = this.findSingle(d, T);
                  P && l(P) && t.push(P);
                }
              } catch (k) {
                b.e(k);
              } finally {
                b.f();
              }
            }
            d.nodeType !== 9 && l(d) && t.push(d);
          }
        } catch (k) {
          u.e(k);
        } finally {
          u.f();
        }
      }
      return t;
    }
  }, {
    key: "getHiddenElementOuterHeight",
    value: function(e) {
      if (e) {
        e.style.visibility = "hidden", e.style.display = "block";
        var t = e.offsetHeight;
        return e.style.display = "none", e.style.visibility = "visible", t;
      }
      return 0;
    }
  }, {
    key: "getHiddenElementOuterWidth",
    value: function(e) {
      if (e) {
        e.style.visibility = "hidden", e.style.display = "block";
        var t = e.offsetWidth;
        return e.style.display = "none", e.style.visibility = "visible", t;
      }
      return 0;
    }
  }, {
    key: "getHiddenElementDimensions",
    value: function(e) {
      var t = {};
      return e && (e.style.visibility = "hidden", e.style.display = "block", t.width = e.offsetWidth, t.height = e.offsetHeight, e.style.display = "none", e.style.visibility = "visible"), t;
    }
  }, {
    key: "fadeIn",
    value: function(e, t) {
      if (e) {
        e.style.opacity = 0;
        var n = +new Date(), o = 0, l = function u() {
          o = +e.style.opacity + (new Date().getTime() - n) / t, e.style.opacity = o, n = +new Date(), +o < 1 && (window.requestAnimationFrame && requestAnimationFrame(u) || setTimeout(u, 16));
        };
        l();
      }
    }
  }, {
    key: "fadeOut",
    value: function(e, t) {
      if (e)
        var n = 1, o = 50, l = o / t, u = setInterval(function() {
          n -= l, n <= 0 && (n = 0, clearInterval(u)), e.style.opacity = n;
        }, o);
    }
  }, {
    key: "getUserAgent",
    value: function() {
      return navigator.userAgent;
    }
  }, {
    key: "isIOS",
    value: function() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
  }, {
    key: "isAndroid",
    value: function() {
      return /(android)/i.test(navigator.userAgent);
    }
  }, {
    key: "isTouchDevice",
    value: function() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
  }, {
    key: "isFunction",
    value: function(e) {
      return !!(e && e.constructor && e.call && e.apply);
    }
  }, {
    key: "appendChild",
    value: function(e, t) {
      if (this.isElement(t))
        t.appendChild(e);
      else if (t.el && t.el.nativeElement)
        t.el.nativeElement.appendChild(e);
      else
        throw new Error("Cannot append " + t + " to " + e);
    }
  }, {
    key: "removeChild",
    value: function(e, t) {
      if (this.isElement(t))
        t.removeChild(e);
      else if (t.el && t.el.nativeElement)
        t.el.nativeElement.removeChild(e);
      else
        throw new Error("Cannot remove " + e + " from " + t);
    }
  }, {
    key: "isElement",
    value: function(e) {
      return (typeof HTMLElement > "u" ? "undefined" : _(HTMLElement)) === "object" ? e instanceof HTMLElement : e && _(e) === "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
    }
  }, {
    key: "scrollInView",
    value: function(e, t) {
      var n = getComputedStyle(e).getPropertyValue("borderTopWidth"), o = n ? parseFloat(n) : 0, l = getComputedStyle(e).getPropertyValue("paddingTop"), u = l ? parseFloat(l) : 0, f = e.getBoundingClientRect(), d = t.getBoundingClientRect(), g = d.top + document.body.scrollTop - (f.top + document.body.scrollTop) - o - u, h = e.scrollTop, b = e.clientHeight, v = this.getOuterHeight(t);
      g < 0 ? e.scrollTop = h + g : g + v > b && (e.scrollTop = h + g - b + v);
    }
  }, {
    key: "clearSelection",
    value: function() {
      if (window.getSelection)
        window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0 && window.getSelection().removeAllRanges();
      else if (document.selection && document.selection.empty)
        try {
          document.selection.empty();
        } catch {
        }
    }
  }, {
    key: "calculateScrollbarWidth",
    value: function(e) {
      if (e) {
        var t = getComputedStyle(e);
        return e.offsetWidth - e.clientWidth - parseFloat(t.borderLeftWidth) - parseFloat(t.borderRightWidth);
      } else {
        if (this.calculatedScrollbarWidth != null)
          return this.calculatedScrollbarWidth;
        var n = document.createElement("div");
        n.className = "p-scrollbar-measure", document.body.appendChild(n);
        var o = n.offsetWidth - n.clientWidth;
        return document.body.removeChild(n), this.calculatedScrollbarWidth = o, o;
      }
    }
  }, {
    key: "getBrowser",
    value: function() {
      if (!this.browser) {
        var e = this.resolveUserAgent();
        this.browser = {}, e.browser && (this.browser[e.browser] = !0, this.browser.version = e.version), this.browser.chrome ? this.browser.webkit = !0 : this.browser.webkit && (this.browser.safari = !0);
      }
      return this.browser;
    }
  }, {
    key: "resolveUserAgent",
    value: function() {
      var e = navigator.userAgent.toLowerCase(), t = /(chrome)[ ]([\w.]+)/.exec(e) || /(webkit)[ ]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(e) || /(msie) ([\w.]+)/.exec(e) || e.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e) || [];
      return {
        browser: t[1] || "",
        version: t[2] || "0"
      };
    }
  }, {
    key: "isVisible",
    value: function(e) {
      return e && (e.clientHeight !== 0 || e.getClientRects().length !== 0 || getComputedStyle(e).display !== "none");
    }
  }, {
    key: "isExist",
    value: function(e) {
      return e !== null && typeof e < "u" && e.nodeName && e.parentNode;
    }
  }, {
    key: "hasDOM",
    value: function() {
      return !!(typeof window < "u" && window.document && window.document.createElement);
    }
  }, {
    key: "getFocusableElements",
    value: function(e) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = i.find(e, 'button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(t, `,
                [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t, `,
                input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t, `,
                select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t, `,
                textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t, `,
                [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t, `,
                [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`).concat(t)), o = [], l = re(n), u;
      try {
        for (l.s(); !(u = l.n()).done; ) {
          var f = u.value;
          getComputedStyle(f).display !== "none" && getComputedStyle(f).visibility !== "hidden" && o.push(f);
        }
      } catch (d) {
        l.e(d);
      } finally {
        l.f();
      }
      return o;
    }
  }, {
    key: "getFirstFocusableElement",
    value: function(e, t) {
      var n = i.getFocusableElements(e, t);
      return n.length > 0 ? n[0] : null;
    }
  }, {
    key: "getLastFocusableElement",
    value: function(e, t) {
      var n = i.getFocusableElements(e, t);
      return n.length > 0 ? n[n.length - 1] : null;
    }
  }, {
    key: "focus",
    value: function(e, t) {
      var n = t === void 0 ? !0 : !t;
      e && document.activeElement !== e && e.focus({
        preventScroll: n
      });
    }
  }, {
    key: "getCursorOffset",
    value: function(e, t, n, o) {
      if (e) {
        var l = getComputedStyle(e), u = document.createElement("div");
        u.style.position = "absolute", u.style.top = "0px", u.style.left = "0px", u.style.visibility = "hidden", u.style.pointerEvents = "none", u.style.overflow = l.overflow, u.style.width = l.width, u.style.height = l.height, u.style.padding = l.padding, u.style.border = l.border, u.style.overflowWrap = l.overflowWrap, u.style.whiteSpace = l.whiteSpace, u.style.lineHeight = l.lineHeight, u.innerHTML = t.replace(/\r\n|\r|\n/g, "<br />");
        var f = document.createElement("span");
        f.textContent = o, u.appendChild(f);
        var d = document.createTextNode(n);
        u.appendChild(d), document.body.appendChild(u);
        var g = f.offsetLeft, h = f.offsetTop, b = f.clientHeight;
        return document.body.removeChild(u), {
          left: Math.abs(g - e.scrollLeft),
          top: Math.abs(h - e.scrollTop) + b
        };
      }
      return {
        top: "auto",
        left: "auto"
      };
    }
  }, {
    key: "invokeElementMethod",
    value: function(e, t, n) {
      e[t].apply(e, n);
    }
  }, {
    key: "isClickable",
    value: function(e) {
      var t = e.nodeName, n = e.parentElement && e.parentElement.nodeName;
      return t === "INPUT" || t === "TEXTAREA" || t === "BUTTON" || t === "A" || n === "INPUT" || n === "TEXTAREA" || n === "BUTTON" || n === "A" || this.hasClass(e, "p-button") || this.hasClass(e.parentElement, "p-button") || this.hasClass(e.parentElement, "p-checkbox") || this.hasClass(e.parentElement, "p-radiobutton");
    }
  }, {
    key: "applyStyle",
    value: function(e, t) {
      if (typeof t == "string")
        e.style.cssText = this.style;
      else
        for (var n in this.style)
          e.style[n] = t[n];
    }
  }, {
    key: "exportCSV",
    value: function(e, t) {
      var n = new Blob([e], {
        type: "application/csv;charset=utf-8;"
      });
      if (window.navigator.msSaveOrOpenBlob)
        navigator.msSaveOrOpenBlob(n, t + ".csv");
      else {
        var o = i.saveAs({
          name: t + ".csv",
          src: URL.createObjectURL(n)
        });
        o || (e = "data:text/csv;charset=utf-8," + e, window.open(encodeURI(e)));
      }
    }
  }, {
    key: "saveAs",
    value: function(e) {
      if (e) {
        var t = document.createElement("a");
        if (t.download !== void 0) {
          var n = e.name, o = e.src;
          return t.setAttribute("href", o), t.setAttribute("download", n), t.style.display = "none", document.body.appendChild(t), t.click(), document.body.removeChild(t), !0;
        }
      }
      return !1;
    }
  }, {
    key: "createInlineStyle",
    value: function(e) {
      var t = document.createElement("style");
      try {
        e || (e = process.env.REACT_APP_CSS_NONCE);
      } catch {
      }
      return e && t.setAttribute("nonce", e), document.head.appendChild(t), t;
    }
  }, {
    key: "removeInlineStyle",
    value: function(e) {
      if (this.isExist(e)) {
        try {
          document.head.removeChild(e);
        } catch {
        }
        e = null;
      }
      return e;
    }
  }, {
    key: "getTargetElement",
    value: function(e) {
      if (!e)
        return null;
      if (e === "document")
        return document;
      if (e === "window")
        return window;
      if (_(e) === "object" && e.hasOwnProperty("current"))
        return this.isExist(e.current) ? e.current : null;
      var t = function(l) {
        return !!(l && l.constructor && l.call && l.apply);
      }, n = t(e) ? e() : e;
      return n && n.nodeType === 9 || this.isExist(n) ? n : null;
    }
  }, {
    key: "getAttributeNames",
    value: function(e) {
      var t, n, o;
      for (n = [], o = e.attributes, t = 0; t < o.length; ++t)
        n.push(o[t].nodeName);
      return n.sort(), n;
    }
  }, {
    key: "isEqualElement",
    value: function(e, t) {
      var n, o, l, u, f;
      if (n = i.getAttributeNames(e), o = i.getAttributeNames(t), n.join(",") !== o.join(","))
        return !1;
      for (var d = 0; d < n.length; ++d)
        if (l = n[d], l === "style")
          for (var g = e.style, h = t.style, b = /^\d+$/, v = 0, T = Object.keys(g); v < T.length; v++) {
            var P = T[v];
            if (!b.test(P) && g[P] !== h[P])
              return !1;
          }
        else if (e.getAttribute(l) !== t.getAttribute(l))
          return !1;
      for (u = e.firstChild, f = t.firstChild; u && f; u = u.nextSibling, f = f.nextSibling) {
        if (u.nodeType !== f.nodeType)
          return !1;
        if (u.nodeType === 1) {
          if (!i.isEqualElement(u, f))
            return !1;
        } else if (u.nodeValue !== f.nodeValue)
          return !1;
      }
      return !(u || f);
    }
  }]), i;
}();
oe(Ne, "DATA_PROPS", ["data-"]);
oe(Ne, "ARIA_PROPS", ["aria", "focus-target"]);
function Dt() {
  var i = /* @__PURE__ */ new Map();
  return {
    on: function(e, t) {
      var n = i.get(e);
      n ? n.push(t) : n = [t], i.set(e, n);
    },
    off: function(e, t) {
      var n = i.get(e);
      n && n.splice(n.indexOf(t) >>> 0, 1);
    },
    emit: function(e, t) {
      var n = i.get(e);
      n && n.slice().forEach(function(o) {
        return o(t);
      });
    }
  };
}
function kt(i) {
  if (Array.isArray(i))
    return ne(i);
}
function _t(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null)
    return Array.from(i);
}
function Pt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Me(i) {
  return kt(i) || _t(i) || De(i) || Pt();
}
var Ft = /* @__PURE__ */ function() {
  function i() {
    ae(this, i);
  }
  return ie(i, null, [{
    key: "equals",
    value: function(e, t, n) {
      return n && e && _(e) === "object" && t && _(t) === "object" ? this.resolveFieldData(e, n) === this.resolveFieldData(t, n) : this.deepEquals(e, t);
    }
  }, {
    key: "deepEquals",
    value: function(e, t) {
      if (e === t)
        return !0;
      if (e && t && _(e) == "object" && _(t) == "object") {
        var n = Array.isArray(e), o = Array.isArray(t), l, u, f;
        if (n && o) {
          if (u = e.length, u !== t.length)
            return !1;
          for (l = u; l-- !== 0; )
            if (!this.deepEquals(e[l], t[l]))
              return !1;
          return !0;
        }
        if (n !== o)
          return !1;
        var d = e instanceof Date, g = t instanceof Date;
        if (d !== g)
          return !1;
        if (d && g)
          return e.getTime() === t.getTime();
        var h = e instanceof RegExp, b = t instanceof RegExp;
        if (h !== b)
          return !1;
        if (h && b)
          return e.toString() === t.toString();
        var v = Object.keys(e);
        if (u = v.length, u !== Object.keys(t).length)
          return !1;
        for (l = u; l-- !== 0; )
          if (!Object.prototype.hasOwnProperty.call(t, v[l]))
            return !1;
        for (l = u; l-- !== 0; )
          if (f = v[l], !this.deepEquals(e[f], t[f]))
            return !1;
        return !0;
      }
      return e !== e && t !== t;
    }
  }, {
    key: "resolveFieldData",
    value: function(e, t) {
      if (e && Object.keys(e).length && t) {
        if (this.isFunction(t))
          return t(e);
        if (t.indexOf(".") === -1)
          return e[t];
        for (var n = t.split("."), o = e, l = 0, u = n.length; l < u; ++l) {
          if (o == null)
            return null;
          o = o[n[l]];
        }
        return o;
      } else
        return null;
    }
  }, {
    key: "isFunction",
    value: function(e) {
      return !!(e && e.constructor && e.call && e.apply);
    }
  }, {
    key: "findDiffKeys",
    value: function(e, t) {
      return !e || !t ? {} : Object.keys(e).filter(function(n) {
        return !t.hasOwnProperty(n);
      }).reduce(function(n, o) {
        return n[o] = e[o], n;
      }, {});
    }
  }, {
    key: "reduceKeys",
    value: function(e, t) {
      var n = {};
      return !e || !t || t.length === 0 || Object.keys(e).filter(function(o) {
        return t.some(function(l) {
          return o.startsWith(l);
        });
      }).forEach(function(o) {
        n[o] = e[o], delete e[o];
      }), n;
    }
  }, {
    key: "reorderArray",
    value: function(e, t, n) {
      var o;
      if (e && t !== n) {
        if (n >= e.length)
          for (o = n - e.length; o-- + 1; )
            e.push(void 0);
        e.splice(n, 0, e.splice(t, 1)[0]);
      }
    }
  }, {
    key: "findIndexInList",
    value: function(e, t, n) {
      var o = this;
      return t ? n ? t.findIndex(function(l) {
        return o.equals(l, e, n);
      }) : t.findIndex(function(l) {
        return l === e;
      }) : -1;
    }
  }, {
    key: "getJSXElement",
    value: function(e) {
      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
        n[o - 1] = arguments[o];
      return this.isFunction(e) ? e.apply(void 0, n) : e;
    }
  }, {
    key: "getPropValue",
    value: function(e) {
      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
        n[o - 1] = arguments[o];
      var l = n;
      return n && n.length === 1 && (l = n[0]), this.isFunction(e) ? e.apply(void 0, Me(l)) : e;
    }
  }, {
    key: "getRefElement",
    value: function(e) {
      return e ? _(e) === "object" && e.hasOwnProperty("current") ? e.current : e : null;
    }
  }, {
    key: "combinedRefs",
    value: function(e, t) {
      e && t && (typeof t == "function" ? t(e.current) : t.current = e.current);
    }
  }, {
    key: "removeAccents",
    value: function(e) {
      return e && e.search(/[\xC0-\xFF]/g) > -1 && (e = e.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y")), e;
    }
  }, {
    key: "isEmpty",
    value: function(e) {
      return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && _(e) === "object" && Object.keys(e).length === 0;
    }
  }, {
    key: "isNotEmpty",
    value: function(e) {
      return !this.isEmpty(e);
    }
  }, {
    key: "sort",
    value: function(e, t) {
      var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, o = arguments.length > 3 ? arguments[3] : void 0, l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, u = i.compare(e, t, o, n), f = l === 1 ? n : l;
      return f * u;
    }
  }, {
    key: "compare",
    value: function(e, t, n) {
      var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, l = -1, u = this.isEmpty(e), f = this.isEmpty(t);
      return u && f ? l = 0 : u ? l = o : f ? l = -o : typeof e == "string" && typeof t == "string" ? l = e.localeCompare(t, n, {
        numeric: !0
      }) : l = e < t ? -1 : e > t ? 1 : 0, l;
    }
  }]), i;
}();
function Le(i, a) {
  var e = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(i);
    a && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(i, n).enumerable;
    })), e.push.apply(e, t);
  }
  return e;
}
function At(i) {
  for (var a = 1; a < arguments.length; a++) {
    var e = arguments[a] != null ? arguments[a] : {};
    a % 2 ? Le(Object(e), !0).forEach(function(t) {
      oe(i, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(e)) : Le(Object(e)).forEach(function(t) {
      Object.defineProperty(i, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }
  return i;
}
var Nt = /* @__PURE__ */ function() {
  function i() {
    ae(this, i);
  }
  return ie(i, null, [{
    key: "getJSXIcon",
    value: function(e) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = null;
      if (e !== null) {
        var l = _(e), u = Tt(t.className, l === "string" && e);
        if (o = /* @__PURE__ */ wt("span", {
          ...t,
          className: u
        }), l !== "string") {
          var f = At({
            iconProps: t,
            element: o
          }, n);
          return Ft.getJSXElement(e, f);
        }
      }
      return o;
    }
  }]), i;
}(), je = 0;
function Mt() {
  var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pr_id_";
  return je++, "".concat(i).concat(je);
}
function It() {
  var i = [], a = function(u, f) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 999, g = n(u, f, d), h = g.value + (g.key === u ? 0 : d) + 1;
    return i.push({
      key: u,
      value: h
    }), h;
  }, e = function(u) {
    i = i.filter(function(f) {
      return f.value !== u;
    });
  }, t = function(u, f) {
    return n(u, f).value;
  }, n = function(u, f) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Me(i).reverse().find(function(g) {
      return f ? !0 : g.key === u;
    }) || {
      key: u,
      value: d
    };
  }, o = function(u) {
    return u && parseInt(u.style.zIndex, 10) || 0;
  };
  return {
    get: o,
    set: function(u, f, d, g) {
      f && (f.style.zIndex = String(a(u, d, g)));
    },
    clear: function(u) {
      u && (e(Wt.get(u)), u.style.zIndex = "");
    },
    getCurrent: function(u, f) {
      return t(u, f);
    }
  };
}
var Wt = It();
export {
  Ne as DomHandler,
  Dt as EventBus,
  jt as Fragment,
  Nt as IconUtils,
  Ft as ObjectUtils,
  Mt as UniqueComponentId,
  Wt as ZIndexUtils,
  Tt as classNames,
  wt as jsx,
  Ht as jsxs
};
